<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">拆除方案评审</h4>
      </div>

      <div class="form">
        <el-form :model="ruleForm" ref="ruleForm" label-width="150px">
          <div class="title-little-subheading">
            公告信息
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="公告编号:">
                <span>{{ ruleForm.code }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公告标题:">
                <span>{{ ruleForm.title }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="竞价开始时间:">
                <span>{{ ruleForm.bidStartTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="购买商:">
                <span>{{ ruleForm.compName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="title-little-subheading">
            拆除方案信息
          </div>
          <el-form-item label="拆除方案附件:">
            <div
              v-for="(item, index) in ruleForm.fileList"
              :key="index"
              @click="onDownload(item)"
              class="cell-link"
            >
              {{ item.fileName }}
            </div>
          </el-form-item>
          <el-form-item label="说明:"
            ><span>{{ ruleForm.remark }}</span></el-form-item
          >
        </el-form>
        <div class="title-little-subheading">
          评审结果
        </div>
        <div class="form">
          <el-form :model="formAudit" ref="formAudit" label-width="150px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="评审结果:" v-if="typequery == 1">
                  <span>{{
                    ruleForm.auditWhether == 1
                      ? '通过'
                      : ruleForm.auditWhether == 2
                      ? '不通过'
                      : ''
                  }}</span>
                </el-form-item>
                <el-form-item
                  label="评审结果:"
                  :rules="[
                    {
                      required: true,
                      message: '请选择评审结果',
                      trigger: 'change'
                    }
                  ]"
                  prop="auditWhether"
                  v-else
                >
                  <el-radio v-model="formAudit.auditWhether" :label="1"
                    >通过</el-radio
                  >
                  <el-radio v-model="formAudit.auditWhether" :label="2"
                    >不通过</el-radio
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              label="评审说明:"
              prop="auditRemark"
              :rules="
                formAudit.auditWhether == 2
                  ? [
                      {
                        required: true,
                        message: ' ',
                        trigger: 'blur'
                      }
                    ]
                  : []
              "
            >
              <span v-if="typequery == 1">{{ ruleForm.auditRemark }}</span>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                v-model="formAudit.auditRemark"
                maxlength="200"
                show-word-limit
                v-else
              >
              </el-input>
            </el-form-item>
            <on-Upload
              :checkFlag="typequery == 1"
              labelName="评审附件"
              @fileDataSingle="fileDataSingle"
              :fileList="formAudit.auditFileList"
            >
            </on-Upload>
          </el-form>
        </div>
      </div>
      <div class="page-index-footer">
        <el-button @click="submit" type="primary" v-if="typequery != 1"
          >确定</el-button
        >
        <el-button @click="down">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {},
      formAudit: { auditFileList: [], auditWhether: '', auditRemark: '' }
    }
  },
  computed: {
    typequery() {
      return this.$route.query.typequery
    }
  },
  created() {
    this.getDismantlePlan()
  },
  methods: {
    async getDismantlePlan() {
      let params = {
        buyerCompCode: this.$route.query.buyerCompCode,
        noticeId: this.$route.query.noticeID
      }
      let data = await this.$api.serviceProvider.getDismantlePlan(params)
      this.ruleForm = data
      if (this.typequery == 1) {
        this.formAudit.auditFileList = data.auditFileList
      }
    },
    fileDataSingle(val) {
      this.formAudit.auditFileList = val
    },
    submit() {
      this.$refs.formAudit.validate(async valid => {
        if (valid) {
          let query = {
            id: this.ruleForm.id,
            fileList: this.formAudit.auditFileList,
            auditWhether: this.formAudit.auditWhether,
            auditRemark: this.formAudit.auditRemark
          }
          let data = await this.$api.serviceProvider.auditDismantlePlan(query)
          if (data) {
            this.$message.success('提交成功')
            this.$router.go(-1)
          }
        }
      })
    },
    down() {
      this.$router.go(-1)
    },
    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
